const SERVER_API = "https://blogs.shenshimen.cn/api/"

export {
    SERVER_API
}
